module.exports = __webpack_public_path__ + "templates.product_customer_review-87580ba3.html";